import { generateTotalExpression } from 'utilities';
import { GetValuationsExpressionsParams } from './getValuationsExpressions.types';

const getValuationsExpressions = (params: GetValuationsExpressionsParams) => {
  const { alphabet, areFundInvestmentsEnabled, columns, excludedRowsCount, FUND_SUMMARY_SPREADSHEET_COLUMNS } = params;

  // Published valuations
  const allPublishedValuations = [] as number[];

  // Set all Published valuations
  Object.values(columns[FUND_SUMMARY_SPREADSHEET_COLUMNS.INVESTED_CAPITAL - 1]) // -1 excluding Company Column
    .forEach((row, rowIndex) => {
      const { disabled, isFundInvestment = false } = row;

      if (!disabled && !isFundInvestment) {
        let rowNumber = rowIndex + excludedRowsCount;

        if (areFundInvestmentsEnabled) {
          rowNumber += 1; // Add Direct Investments label row
        }

        allPublishedValuations.push(rowNumber);
      } // + 2 excluding Index and Header
    });

  // All Published valuations expression
  const allPublishedValuationsExpression = generateTotalExpression({
    items: allPublishedValuations,
    generateIndex: false,
  });

  // Columns legends (-1 excluding Company Column)
  const totalValueColLegend = alphabet[FUND_SUMMARY_SPREADSHEET_COLUMNS.TOTAL_VALUE - 1];

  return {
    allPublishedValuationsExpression,
    totalValueColLegend,
  };
};

export default getValuationsExpressions;
